module.exports = __webpack_public_path__ + "media/images/input-arrow-8694c661edea0081c4e21b34727491a5.svg";